"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendConfig = sendConfig;
var _sendMessage = require("../send-message");
var _context = require("../context");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Send Config
 * - Sends configuration to the SDK
 *
 * @module core-bootstrap-dispatch-send-config
 */

/**
 * Send a new configuration to the SDK loaded in an iframe
 *
 * @param {object} data A data object containing the nonce
 * @param {string} [id] The ID of the target SDK
 */
function sendConfig(data, id) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return;
  }
  var nonce = data.nonce;
  if (nonce && !iframeEntry.nonce) {
    iframeEntry.nonce = nonce;
  }
  (0, _sendMessage.sendMessage)('setConfig', iframeEntry.config, id);
}
//# sourceMappingURL=send-config.js.map